import { io } from 'socket.io-client';

const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || 
                    (process.env.NODE_ENV === "production" 
                      ? "https://api.pesacore.fr"
                      : "https://localhost:5000");

class MonitorSocket {
  constructor() {
    this.socket = null;
    this.connected = false;
    this.listeners = new Map();
  }

  connect() {
    if (this.socket?.connected) return;
    const isDev = process.env.NODE_ENV === 'development';

    this.socket = io(`${SOCKET_URL}/monitor`, {
      withCredentials: true,
      transports: isDev ? ['polling'] : ['polling', 'websocket'],
      reconnection: true,
      reconnectionAttempts: 5,
      reconnectionDelay: 2000,
    });

    this.socket.on('connect', () => {
      console.log('[MONITOR] Connecté');
      this.connected = true;
      this.socket.emit('monitor:subscribe', { metricsInterval: 5000, logs: true });
      this._emit('connected');
    });

    this.socket.on('connect_error', (err) => {
      console.error('[MONITOR] Erreur:', err.message);
      this.connected = false;
      this._emit('connect_error', err);
    });

    this.socket.on('disconnect', (reason) => {
      this.connected = false;
      this._emit('disconnect', reason);
    });

    // Forward des events serveur
    ['system:metrics', 'system:services', 'system:log', 'system:alert', 'monitor:pong', 'user:activity'].forEach(event => {
      this.socket.on(event, (data) => this._emit(event, data));
    });
  }

  disconnect() {
    this.socket?.disconnect();
    this.socket = null;
    this.connected = false;
  }

  emit(event, data) {
    this.socket?.emit(event, data);
  }

  on(event, cb) {
    if (!this.listeners.has(event)) this.listeners.set(event, []);
    this.listeners.get(event).push(cb);
    return () => this.off(event, cb);
  }

  off(event, cb) {
    const cbs = this.listeners.get(event) || [];
    this.listeners.set(event, cbs.filter(c => c !== cb));
  }

  _emit(event, data) {
    (this.listeners.get(event) || []).forEach(cb => {
      try { cb(data); } catch(e) { console.error(e); }
    });
  }
}

const monitorSocket = new MonitorSocket();
export default monitorSocket;